export const splitHtml = (html) => {
  if (typeof html !== 'string') return [];

  const parser = new DOMParser();
  const { body } = parser.parseFromString(html, 'text/html');

  if (body.childNodes.length === 1) return [html];

  const middle = Math.ceil(body.childNodes.length / 2);
  let chunk1 = '';
  let chunk2 = '';

  const serializer = new XMLSerializer();

  body.childNodes.forEach((node, i) => {
    const nodeHtml = serializer.serializeToString(node);

    if (i < middle) chunk1 += nodeHtml;
    else chunk2 += nodeHtml;
  });

  return [chunk1, chunk2];
};
